import "@/App.css";
import React from "react";
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/auth/ProtectedRoute";
import Shell from "@/components/Shell";
import LoginPage from "@/pages/LoginPage";
import HomePage from "@/pages/HomePage";
import AlbaranesPage from "@/pages/AlbaranesPage";
import ManualDecaPage from "@/pages/ManualDecaPage";
import PreviewPage from "@/pages/PreviewPage";
import GeneratedPage from "@/pages/GeneratedPage";
import DecaListPage from "@/pages/DecaListPage";
import DecaDetailPage from "@/pages/DecaDetailPage";
import InformesPage from "@/pages/InformesPage";
import ConductorPage from "@/pages/ConductorPage";
import ConductoresMantPage from "@/pages/ConductoresMantPage";
import MatriculasMantPage from "@/pages/MatriculasMantPage";
import TransportistasMantPage from "@/pages/TransportistasMantPage";
import ClientesMantPage from "@/pages/ClientesMantPage";
import ProveedoresMantPage from "@/pages/ProveedoresMantPage";
import CargadoresMantPage from "@/pages/CargadoresMantPage";
import AuditoriaPage from "@/pages/AuditoriaPage";
import EmpresasMantPage from "@/pages/EmpresasMantPage";
import UsuariosPage from "@/pages/UsuariosPage";
import PublicVerifyPage from "@/pages/PublicVerifyPage";
import PublicFirmaPage from "@/pages/PublicFirmaPage";
import PublicRutaPage from "@/pages/PublicRutaPage";
import PublicDownloadPage from "@/pages/PublicDownloadPage";
import DecaPdfPage from "@/pages/DecaPdfPage";
import MapaPage from "@/pages/MapaPage";

function AppShell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <Shell>{children}</Shell>
    </ProtectedRoute>
  );
}

function Root() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" richColors />
      <Outlet />
    </AuthProvider>
  );
}

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/verify/:token", element: <PublicVerifyPage /> },
      { path: "/firmar/:token", element: <PublicFirmaPage /> },
      { path: "/d/:token", element: <PublicDownloadPage /> },
      { path: "/r/:token", element: <PublicRutaPage /> },
      { path: "/mapa", element: <AppShell roles={["empresa", "gestoria"]}><MapaPage /></AppShell> },
      { path: "/", element: <AppShell><HomePage /></AppShell> },
      { path: "/albaranes", element: <AppShell roles={["empresa", "gestoria"]}><AlbaranesPage /></AppShell> },
      { path: "/decas/manual", element: <AppShell roles={["empresa", "gestoria"]}><ManualDecaPage /></AppShell> },
      { path: "/decas/preview", element: <AppShell roles={["empresa", "gestoria"]}><PreviewPage /></AppShell> },
      { path: "/decas/generados", element: <AppShell roles={["empresa", "gestoria"]}><GeneratedPage /></AppShell> },
      { path: "/decas", element: <AppShell roles={["empresa", "gestoria", "conductor"]}><DecaListPage /></AppShell> },
      { path: "/decas/:id/pdf", element: <ProtectedRoute roles={["empresa", "gestoria", "conductor"]}><DecaPdfPage /></ProtectedRoute> },
      { path: "/decas/:id", element: <AppShell roles={["empresa", "gestoria", "conductor"]}><DecaDetailPage /></AppShell> },
      { path: "/informes", element: <AppShell roles={["empresa", "gestoria"]}><InformesPage /></AppShell> },
      { path: "/transportistas", element: <AppShell roles={["empresa", "gestoria"]}><TransportistasMantPage /></AppShell> },
      { path: "/clientes", element: <AppShell roles={["empresa", "gestoria"]}><ClientesMantPage /></AppShell> },
      { path: "/proveedores", element: <AppShell roles={["empresa", "gestoria"]}><ProveedoresMantPage /></AppShell> },
      { path: "/cargadores", element: <AppShell roles={["empresa", "gestoria"]}><CargadoresMantPage /></AppShell> },
      { path: "/conductores", element: <AppShell roles={["empresa", "gestoria"]}><ConductoresMantPage /></AppShell> },
      { path: "/matriculas", element: <AppShell roles={["empresa", "gestoria"]}><MatriculasMantPage /></AppShell> },
      { path: "/conductor", element: <AppShell roles={["conductor", "empresa"]}><ConductorPage /></AppShell> },
      { path: "/auditoria", element: <AppShell roles={["admin", "empresa", "gestoria"]}><AuditoriaPage /></AppShell> },
      { path: "/empresas", element: <AppShell roles={["admin"]}><EmpresasMantPage /></AppShell> },
      { path: "/usuarios", element: <AppShell roles={["admin"]}><UsuariosPage /></AppShell> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

export default function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}
